import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class Payroll  {
    _originalTypeClassName = "zERP.BO.Payroll";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
Payroll.translate = translateService;
}
this.Entity = new Domain.BusinessEntity();
this.GeneralJournals = [];
this.AdvanceGeneralJournalEntities = [];
this.Calculations = [];
this.Id = null;
this.CreatedOn = null;
this.Status = null;
this.IssuedOn = null;
this.FMY = null;
this.PayableAmount = null;
this.AdvanceAmount = null;
this.MappedWithAccounting = false;
this.PaymentDate = null;
this.DateClosed = null;
this.DateSyncedWithAccounting = null;
this.DateFMYExported = null;
this.DateAdvanceSyncedWithAccounting = null;
this.AdvancePaymentOn = null;
this.DateAPDExported = null;
this.Description = null;
this.AdvanceBankFileDate = null;
this.IssueBankFileDate = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
CreatedOn:any;
Status:any;
IssuedOn:any;
FMY:any;
PayableAmount:any;
AdvanceAmount:any;
MappedWithAccounting:any;
PaymentDate:any;
DateClosed:any;
DateSyncedWithAccounting:any;
DateFMYExported:any;
DateAdvanceSyncedWithAccounting:any;
AdvancePaymentOn:any;
DateAPDExported:any;
Description:any;
AdvanceBankFileDate:any;
IssueBankFileDate:any;
Entity:any;
IssuedBy:any;
GeneralJournals:any;
Invoice:any;
FMYExport:any;
AdvanceGeneralJournalEntities:any;
AdvanceInvoice:any;
AdvancePaymentOrder:any;
PaymentOrder:any;
BankAccount:any;
Calculations:any;
BankExportFile:any;
static setEntity = ($this, value) => {
var oldValue = $this.Entity;
$this.Entity = value;
if (value != null) {
}
}
static setIssuedBy = ($this, value) => {
var oldValue = $this.IssuedBy;
$this.IssuedBy = value;
if (value != null) {
}
}
static setGeneralJournals = ($this, items) => {
                if (items == null) items = [];
                if ($this.GeneralJournals == null) $this.GeneralJournals = [];

                const copyItems = Common.cloneObject(items);

                while ($this.GeneralJournals.length > 0) {
                    Domain.Payroll.removeGeneralJournals($this, $this.GeneralJournals[0]);
                }

                Domain.Payroll.addManyGeneralJournals($this, copyItems);
            }
static addManyGeneralJournals = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Payroll.addGeneralJournals($this, items[i]);
                }
            }
static addGeneralJournals = ($this, item) => {
                if ($this.GeneralJournals == null) $this.GeneralJournals = [];
                if (item == null || $this.GeneralJournals.indexOf(item) > -1) return;
                $this.GeneralJournals.push(item);
}
static addRangeGeneralJournals = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Payroll.addGeneralJournals($this, item));
            }
static removeGeneralJournals = ($this, item) => {
                if ($this == null || $this.GeneralJournals == null || $this.GeneralJournals.indexOf(item) === -1) return;
                var _index = $this.GeneralJournals.indexOf(item);
                $this.GeneralJournals.splice(_index, 1);
}
static clearGeneralJournals = ($this) => { $this.GeneralJournals = null; }
static setInvoice = ($this, value) => {
var oldValue = $this.Invoice;
$this.Invoice = value;
if (value != null) {
}
}
static setFMYExport = ($this, value) => {
var oldValue = $this.FMYExport;
$this.FMYExport = value;
if (value != null) {
if (oldValue != null) {
Domain.PayrollFMYExport.removePayrolls(oldValue, $this);
}
Domain.PayrollFMYExport.addPayrolls(value, $this);
}
}
static setAdvanceGeneralJournalEntities = ($this, items) => {
                if (items == null) items = [];
                if ($this.AdvanceGeneralJournalEntities == null) $this.AdvanceGeneralJournalEntities = [];

                const copyItems = Common.cloneObject(items);

                while ($this.AdvanceGeneralJournalEntities.length > 0) {
                    Domain.Payroll.removeAdvanceGeneralJournalEntities($this, $this.AdvanceGeneralJournalEntities[0]);
                }

                Domain.Payroll.addManyAdvanceGeneralJournalEntities($this, copyItems);
            }
static addManyAdvanceGeneralJournalEntities = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Payroll.addAdvanceGeneralJournalEntities($this, items[i]);
                }
            }
static addAdvanceGeneralJournalEntities = ($this, item) => {
                if ($this.AdvanceGeneralJournalEntities == null) $this.AdvanceGeneralJournalEntities = [];
                if (item == null || $this.AdvanceGeneralJournalEntities.indexOf(item) > -1) return;
                $this.AdvanceGeneralJournalEntities.push(item);
}
static addRangeAdvanceGeneralJournalEntities = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Payroll.addAdvanceGeneralJournalEntities($this, item));
            }
static removeAdvanceGeneralJournalEntities = ($this, item) => {
                if ($this == null || $this.AdvanceGeneralJournalEntities == null || $this.AdvanceGeneralJournalEntities.indexOf(item) === -1) return;
                var _index = $this.AdvanceGeneralJournalEntities.indexOf(item);
                $this.AdvanceGeneralJournalEntities.splice(_index, 1);
}
static clearAdvanceGeneralJournalEntities = ($this) => { $this.AdvanceGeneralJournalEntities = null; }
static setAdvanceInvoice = ($this, value) => {
var oldValue = $this.AdvanceInvoice;
$this.AdvanceInvoice = value;
if (value != null) {
}
}
static setAdvancePaymentOrder = ($this, value) => {
var oldValue = $this.AdvancePaymentOrder;
$this.AdvancePaymentOrder = value;
if (value != null) {
}
}
static setPaymentOrder = ($this, value) => {
var oldValue = $this.PaymentOrder;
$this.PaymentOrder = value;
if (value != null) {
}
}
static setBankAccount = ($this, value) => {
var oldValue = $this.BankAccount;
$this.BankAccount = value;
if (value != null) {
}
}
static setCalculations = ($this, items) => {
                if (items == null) items = [];
                if ($this.Calculations == null) $this.Calculations = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Calculations.length > 0) {
                    Domain.Payroll.removeCalculations($this, $this.Calculations[0]);
                }

                Domain.Payroll.addManyCalculations($this, copyItems);
            }
static addManyCalculations = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Payroll.addCalculations($this, items[i]);
                }
            }
static addCalculations = ($this, item) => {
                if ($this.Calculations == null) $this.Calculations = [];
                if (item == null || $this.Calculations.indexOf(item) > -1) return;
                $this.Calculations.push(item);
if (item.Payroll != $this) {
Domain.PayrollCalculation.setPayroll(item, $this);
}
}
static addRangeCalculations = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Payroll.addCalculations($this, item));
            }
static removeCalculations = ($this, item) => {
                if ($this == null || $this.Calculations == null || $this.Calculations.indexOf(item) === -1) return;
                var _index = $this.Calculations.indexOf(item);
                $this.Calculations.splice(_index, 1);
item.Payroll = null;
}
static clearCalculations = ($this) => { $this.Calculations = null; }
static setBankExportFile = ($this, value) => {
var oldValue = $this.BankExportFile;
$this.BankExportFile = value;
if (value != null) {
if (oldValue != null && oldValue.Payroll != null) { oldValue.Payroll = null; }
if ($this.BankExportFile.Payroll !== $this) {
Domain.PayrollBankExport.setPayroll(value, $this);
}
}
}

static CanBeDeleted($this: any): any{return !(Domain.Payroll.IsNew($this)) && $this?.AdvanceInvoice == null && CLMS.Framework.Number.Equal(() => $this.AdvanceGeneralJournalEntities.length, () => 0) && $this?.Invoice == null && CLMS.Framework.Number.Equal(() => $this.GeneralJournals.length, () => 0);
}
static GetAllEmployees(calculations: any): any{let employees = [];
for (let _icalculation = 0; _icalculation < (calculations == null ? 0 : calculations.length); _icalculation++) {let calculation = calculations[_icalculation];for (let _iemployee = 0; _iemployee < (calculation?.Employees == null ? 0 : calculation?.Employees.length); _iemployee++) {let employee = calculation?.Employees[_iemployee];if (!(employees?.linq?.any((e) => e == employee?.Employee))) {employees?.add(employee?.Employee);}}}
return employees;
}
static GetClassName(): any{return CLMS.Framework.Utilities.ThrowException("StdLib.RuntimeType.Name()").Test;
}
static GetDescription($this: any): any{let parts = [];
if ($this?.Entity != null) {parts?.add($this?.Entity?.ShortName);}
if ($this?.PaymentDate != null) {parts?.add(CLMS.Framework.DateTime.ToString($this?.PaymentDate, "dd/MM/yyyy"));}
switch ($this?.Status) {case Domain.PayrollStatus.Draft:
{
parts?.add("Πρόχειρο");break;
}
case Domain.PayrollStatus.Calculating:
{
parts?.add("Υπολογισμοί");break;
}
case Domain.PayrollStatus.Completed:
{
parts?.add("Ολοκληρωμένο");break;
}
case Domain.PayrollStatus.Cancelled:
{
parts?.add("Ακυρομένο");break;
}
}
return CLMS.Framework.String.Join(" - ", parts);
}
static GetPayrollCalculationFileName(payroll: any,payrollCalculation: any): any{let calculationPeriod = payrollCalculation?.Period?.Name;
let calculatioType = payrollCalculation?.Type?.Name;
let generatedDate = CLMS.Framework.DateTime.ToString(moment().toDate(), "ddMMyyyy HHmm");
let fileName = payroll?.Entity?.Name + "_" + calculationPeriod + "_" + calculatioType + "_" + Domain.PayrollStatusHelper.GetPayrollStatusName(payroll?.Status) + "_" + CLMS.Framework.DateTime.ToString(payroll?.PaymentDate, "ddMMyyyy") + "_" + generatedDate;
return fileName;
}
static GetPayrollFileName(payroll: any): any{let calculationPeriod = "";
let calculationPeriodCount = 0;
let calculatioType = "";
let calculatioTypeCount = 0;
let generatedDate = CLMS.Framework.DateTime.ToString(moment().toDate(), "ddMMyyyy HHmm");
for (let _icalculation = 0; _icalculation < (payroll?.Calculations == null ? 0 : payroll?.Calculations.length); _icalculation++) {let calculation = payroll?.Calculations[_icalculation];if (CLMS.Framework.String.IsNullOrEmpty((calculationPeriod ?? '').trim()) || calculationPeriod != calculation?.Period?.Name) {calculationPeriodCount = Joove.Common.safeNumber(calculationPeriodCount) + Joove.Common.safeNumber(1);calculationPeriod = calculation?.Period?.Name;}if (CLMS.Framework.String.IsNullOrEmpty((calculatioType ?? '').trim()) || calculatioType != calculation?.Type?.Name) {calculatioTypeCount = Joove.Common.safeNumber(calculatioTypeCount) + Joove.Common.safeNumber(1);calculatioType = calculation?.Type?.Name;}}
if (CLMS.Framework.Number.GreaterThan(() => calculationPeriodCount, () => 1)) {calculationPeriod = "Πολλαπλά";}
if (CLMS.Framework.Number.GreaterThan(() => calculatioTypeCount, () => 1)) {calculatioType = "Πολλαπλά";}
let fileName = payroll?.Entity?.Name + "_" + calculationPeriod + "_" + calculatioType + "_" + Domain.PayrollStatusHelper.GetPayrollStatusName(payroll?.Status) + "_" + CLMS.Framework.DateTime.ToString(payroll?.PaymentDate, "ddMMyyyy") + "_" + generatedDate;
return fileName;
}
static SyncSalariesFields(): any{}
static UpdateTotals($this: any): any{$this.FMY = $this?.Calculations?.linq?.sum((e) => e?.FMY);
$this.PayableAmount = $this?.Calculations?.linq?.sum((e) => e?.PayableAmount);
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}